import type { SceneStore } from '@os/doc';

type Listener = (rowId: string, colId: string) => void;

/** Per store, per table: who opens that table's cell editor. Scoped to the store so a preview never opens the live board's cells. */
const listeners = new WeakMap<SceneStore, Map<string, Set<Listener>>>();

/** Asks the table `tableId` to edit one of its cells (the canvas controller resolves the cell; a native double-click never reaches it). */
export function requestCellEdit(store: SceneStore, tableId: string, rowId: string, colId: string): void {
  listeners.get(store)?.get(tableId)?.forEach((l) => l(rowId, colId));
}

export function onCellEditRequest(store: SceneStore, tableId: string, l: Listener): () => void {
  let byTable = listeners.get(store);
  if (!byTable) listeners.set(store, (byTable = new Map()));
  let set = byTable.get(tableId);
  if (!set) byTable.set(tableId, (set = new Set()));
  set.add(l);
  return () => {
    set.delete(l);
    if (!set.size) byTable.delete(tableId);
  };
}
